import { TableCell } from '@mui/material';


import { withStyles } from 'tss-react/mui';


export const InfiniteTableCell = withStyles(TableCell, theme => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(0.5),
    paddingLeft: theme.spacing(2),
  },
  head: {
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
  }
}));
